
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2155039a&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ShopPage.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./ShopPage.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2155039a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ShopPage.vue"),
  /* scopeId */
  "data-v-2155039a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Shop/ShopPage.vue
// module id = 631
// module chunks = 0